import { h } from 'preact';
import { useState, useEffect, useRef } from 'preact/hooks';
import IconCloseSmall from 'utils/icon/icon-close-small.svg';
import IconCaratRightSamll from 'utils/icon/icon-carat-right-small.svg';
import IconLeftSmall from 'utils/icon/icon-left-small.svg';
import Panel from 'utils/panel';

const SupergoopModal = ({ title, cards }) => {
  const closeTriggerEl = useRef(null);
  const promoBar = document.querySelector('[data-section="promo-bar"]');
  const [panelTriggers, setPanelTriggers] = useState({
    openTriggerEl: document.querySelector('[data-supergoop-trigger]'),
    closeTriggerEl: null,
  });

  useEffect(() => {
    if (!closeTriggerEl.current) return;
    setPanelTriggers((value) => ({
      ...value,
      closeTriggerEl: closeTriggerEl.current,
    }));

  }, [closeTriggerEl]);

  return (
    <div>
      <Panel
        triggers={panelTriggers}
        showBackdrop={true}
        context="supergoop"
        additionalClasses="!max-w-[440px]"
      >
        <div className="overflow-y-auto h-full">
          <div className="max-lg:w-full max-lg:fixed max-lg:bg-white max-lg:h-[70px] max-lg:top-0 max-lg:left-0 max-lg:z-[2] lg:text-right lg:-mb-6">
            {/* close all navigation at mobile button */}
            <button
              className="absolute top-4 max-lg:right-2.5 lg:hidden"
              type="button"
              tabIndex="0"
              aria-label={window.TMW.Strings.accessibility.close}
              onClick={() => {
                document.body.style.overflow = '';
                document.body.style.overflow = 'hidden';
                document.querySelector('[data-header="nav"]').classList.toggle('hidden')
                document.dispatchEvent(new CustomEvent('close-all-panels'));
              }}
            >
              <div className="text-white hover:text-supergoop-yellow">
                <IconCloseSmall />
              </div>
            </button>
            {/* close current Panel button */}
            <button
              className="absolute top-4 max-lg:left-2.5 lg:right-4 lg:static lg:mr-5 lg:mt-5"
              type="button"
              tabIndex="0"
              aria-label={window.TMW.Strings.accessibility.close}
              ref={closeTriggerEl}
            >
              <div className="text-white hover:text-supergoop-yellow">
                <span className="max-lg:hidden">
                  <IconCloseSmall />
                </span>
                <span className="lg:hidden">
                  <IconLeftSmall />
                </span>
              </div>
            </button>
          </div>
          <div className="max-lg:pt-8 max-lg:mt-10 mx-5 lg:mx-10 mb-[50px]">
            {!!title && (
              <div className="sub-h4 pr-5 mb-5">
                {title}
              </div>
            )}
            {!!cards.length && (
              <div className="mb-5">
                {cards.filter(card => card.url).map((item) => (
                  <a key={item.id} href={item.url} className="block cursor-pointer w-full h-[139px] relative mb-2.5 lg:[&_img]:rounded [&_img]:object-fill [&_img]:w-full [&_img]:h-full [&>.supergoop-link]:hover:text-supergoop-yellow">
                    <img src={item.image} alt={item.title} />
                    {!!item.title && (
                      <div className="absolute pr-[50px] sub-h6 text-black bottom-0 pl-[10px] pb-[10px] lg:pl-[16px] lg:pb-[14px]">
                        {item.title}
                      </div>
                    )}
                    {!!item.url && (
                      <div
                        className="supergoop-link absolute bottom-0 pr-[10px] pb-[13px] lg:pr-[16px] lg:pb-[14px] right-0 text-white hover:text-supergoop-yellow">
                        <IconCaratRightSamll />
                      </div>
                    )}
                  </a>
                ))}
              </div>
            )}
          </div>
        </div>
      </Panel>
    </div>
  );
};

export default SupergoopModal;
